export default {
    PENDENTE: {texto: 'Pendente', valor: 'PENDENTE'},
    ERRO: {texto: 'Erro', valor: 'ERRO'},
    CONCLUIDO: {texto: 'Concluído', valor: 'CONCLUIDO'},
    PROCESSADO: {texto: 'Processado', valor: 'PROCESSADO'},
    CANCELADO: {texto: 'Cancelado', valor: 'CANCELADO'}
}
